export default {
  'userProfile.tab.basic': 'Account',
  'userProfile.tab.salary': 'Salary',
  'userProfile.tab.wallet': 'Wallet',
  'userProfile.tab.authority': 'Permission',
  'userProfile.tab.updateAvatar': 'Edit Avatar',
  'userProfile.tab.teachingInfo': 'Teaching Info',
};
